export const radioTheme = {
    size: '0.875rem',
    background: {
        color: {
            base: (props) => props.theme.palette.surfaceAlt,
            hover: (props) => props.theme.palette.surfaceAlt,
            focus: (props) => props.theme.palette.surfaceAlt,
            disabled: (props) => props.theme.palette.surfaceAlt,
        },
    },
    radio: {
        size: '0.5rem',
        color: {
            disabled: (props) => props.theme.palette.secondaryAlt,
        },
    },
    border: {
        color: {
            base: (props) => props.theme.palette.secondaryAlt,
            disabled: (props) => props.theme.palette.secondaryAlt,
        },
    },
    focus: {
        shadow: {
            size: '3px',
        },
        color: (props) => props.theme.palette.primary,
    },
    // variants
    none: {
        radio: {
            color: {
                active: (props) => props.theme.palette.primary,
            },
        },
        border: {
            color: {
                base: (props) => props.theme.palette.secondaryAlt,
                hover: (props) => props.theme.palette.primary,
                active: (props) => props.theme.palette.primary,
            },
        },
    },
    success: {
        radio: {
            color: {
                active: (props) => props.theme.palette.success,
            },
        },
        border: {
            color: {
                base: (props) => props.theme.palette.success,
                hover: (props) => props.theme.palette.success,
                active: (props) => props.theme.palette.success,
            },
        },
    },
    error: {
        radio: {
            color: {
                active: (props) => props.theme.palette.error,
            },
        },
        border: {
            color: {
                base: (props) => props.theme.palette.error,
                hover: (props) => props.theme.palette.error,
                active: (props) => props.theme.palette.error,
            },
        },
    },
    warning: {
        radio: {
            color: {
                active: (props) => props.theme.palette.warning,
            },
        },
        border: {
            color: {
                base: (props) => props.theme.palette.warning,
                hover: (props) => props.theme.palette.warning,
                active: (props) => props.theme.palette.warning,
            },
        },
    },
};
export const typeVariant = (props) => radioTheme[props.validationState];
